import debounce from 'lodash/debounce';

import ApiUtils from 'fk-cp-shared/utils/MapiApiHelper';
import MapiConfig from '../MapiBaseAjaxConfig';
import UAHelper from 'fk-cp-shared/utils/UAHelper';
import IOSNativeCaller from 'fk-cp-shared/components/ios/NativeCaller';

class FDPHelper {
	constructor() {
		this.nc = {};
		this.pc = {};
		this.events = [];
		this.sendData = debounce(this._sendData, 1500).bind(this);
		this.isAndroid = UAHelper._isAndroid();
		this.isIos = UAHelper._isIOS();
	}

	getNavigationContext = () => {
		if (!this.nc.iid) {
			this.nc.iid = this.generateId(16);
		}
		if (!this.nc.fm) {
			this.nc.fm = 'organic';
		}
		return this.nc;
	};

	trackEvent = (_e, force = false, _nc) => {
		this.setNavigationContext(_nc);
		this.events.push(
			Object.assign(_e, {
				t: Date.now()
			})
		);
		if (force) {
			this.flushEvents();
		} else {
			this.timeout = this.sendData();
		}
	};

	pushEvents = data => {
		ApiUtils.fetch(
			'post',
			{
				ajaxConfig: Object.assign({}, MapiConfig.getConfig(), {
					pathname: '/api/3/data/collector/business'
				})
			},
			Object.assign({}, data)
		).then(
			res => {
				return res;
			},
			err => {
				return err;
			}
		);
	};

	generateId(length = 16) {
		return (
			Math.round(Math.pow(36, length + 1) - Math.random() * Math.pow(36, length))
				.toString(36)
				.slice(1) + new Date().getTime().toString()
		);
	}

	setNavigationContext = (navigationContext = {}) => {
		if (navigationContext.pt && navigationContext.pt !== this.nc.pt) {
			this.nc.ppt = this.nc.pt;
		}
		if (navigationContext && navigationContext.pn && navigationContext.pn !== this.nc.pn) {
			this.nc.ppn = this.nc.pn;
		}
		Object.assign(this.nc, navigationContext);
	};

	flushEvents() {
		this.timeout && clearTimeout(this.timeout);
		this._sendData();
	}

	getData() {
		return {
			nc: this.getNavigationContext(),
			e: this.events
		};
	}

	_sendData() {
		const data = this.getData();
		const sendingItems = data.e.length;
		if (sendingItems) {
			this.pushEvents(data);
			this.events = [];
		}
	}
}

export default new FDPHelper();
